import ky from 'ky'
import { httpError } from '../utils/errors'

/**
 * SkuService provides SKU retrieval API services
 */
class SkuService {

    getSku = (skuId) => {
        //console.log('SkuService.getSku()', skuId)
        return new Promise((resolve, reject) => {
            const url = `/api/v2/skus/${skuId}`
            ky.get(url).json()
                .then(result => resolve(result))
                .catch(error => httpError(error).then(er => reject(er)))
        })
    }

    getSkus = () => {
        //console.log('SkuService.getSkus()')
        return new Promise((resolve, reject) => {
            const url = `/api/v2/skus?f=type:credit`
            ky.get(url).json()
                .then(result => resolve(result))
                .catch(error => httpError(error).then(er => reject(er)))
        })
    }
}

// Create a singleton instance of the service to export
const instance = new SkuService();

export default instance;